<template>
  <div class="form-elements">
    <div class="row">
      <div class="col-md-12">
         <vuestic-widget headerText="Exame Psicotecnico">
      <div>
        <form id="form_psico" method="POST">
          <div class="row">
                <div class="col-sm-12">
                    <h4>Dados do Paciente</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <InputIconGroup typeInput="text" idInput="nome" iconInput="fa-info" labelInput="Nome"
                    >
                        Nome
                        &nbsp;
                    </InputIconGroup>
                </div>
                <div class="col-md-3">
                    <InputIconGroup typeInput="text" idInput="cpf" iconInput="fa-info" labelInput="CPF"
                                    >
                        ###.###.###-##
                        &nbsp;
                    </InputIconGroup>
                </div>
                <div class="col-md-3">
                    <DateIconGroup idInput="data_nascimento" iconInput="fa-calendar"
                                   labelInput="Data de nascimento">
                        (AAAA-MM-DD)
                    </DateIconGroup>
                </div>
                <div class="col-md-6">
                    <InputIconGroup typeInput="email" idInput="email" iconInput="fa-envelope-o"
                                    labelInput="E-mail">
                        E-mail do paciente.
                    </InputIconGroup>
                </div>
                <div class="col-md-6">
                    <InputIconGroup idInput="telefone" iconInput="fa-phone" labelInput="Telefone/Celular"
                                    :inputMask="['(##) ####-####', '(##) # ####-####']">
                        (##) ####-#### | (##) # ####-####
                    </InputIconGroup>
                </div>
                <div class="col-md-6">
                    <SelectIconGroup iconInput="fa-user" idInput="sexo" labelInput="Sexo" :optionsInput="generos"
                         :optionsSelected="null">
                     </SelectIconGroup>
                </div>
                <div class="col-md-6">
                    <SelectIconGroup iconInput="fa-user" idInput="tipo_processo" labelInput="Tipo de Processo" :optionsInput="tipos_processo"
                         :optionsSelected="null">
                     </SelectIconGroup>
                </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <h4>Endereço</h4>
                    </div>
                </div>
            <div class="row">
              <div class="col-md-2">
                <InputIconGroup @change="searchCep($event)" typeInput="text" idInput="cep" iconInput="fa-info"
                                labelInput="CEP" :inputMask="['########']">
                  <a href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm"
                     target="_blank">Consulte o CEP por endereço</a>
                </InputIconGroup>
              </div>
              <div class="col-md-3">
                <InputIconGroup typeInput="text" idInput="logradouro" iconInput="fa-info"
                                labelInput="Logradouro" >
                  Logradouro
                </InputIconGroup>
              </div>
              <div class="col-md-2">
                <InputIconGroup typeInput="text" idInput="numero" iconInput="fa-info"
                                labelInput="Número">
                  Número
                  &nbsp;
                </InputIconGroup>
              </div>
              <div class="col-md-2">
                <InputIconGroup typeInput="text" idInput="bairro" iconInput="fa-info"
                                labelInput="Bairro" >
                  Bairro
                </InputIconGroup>
              </div>
              <div class="col-md-2">
                <InputIconGroup typeInput="text" idInput="cidade" iconInput="fa-info"
                                labelInput="" >
                  Cidade
                </InputIconGroup>
              </div>
              <div class="col-md-1">
                <InputIconGroup typeInput="text" idInput="uf" iconInput="fa-info" labelInput=""
                        >
                  UF
                </InputIconGroup>
              </div>            
            </div>          
            <br>
            <div class="row">
                <div class="col-md-12 text-center">
                    <button class="btn btn-secondary" id="btn_limpar" type="reset">Limpar</button>&nbsp;&nbsp;
                    <button class="btn btn-primary" id="btn_salvar" type="button" @click="salvaInformacoes">
                        Salvar
                    </button>
                </div>
            </div>
        </form>
      </div>
      </vuestic-widget>
    </div>
  </div>
</div>
</template>

<script>
import urlApi from '../../router/urlApi'
import AlunosController from './AlunosController'
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import SelectIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup'
import InputUploadGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputUploadGroup'

export default {
  name: 'form_psico',
  components: {
    InputUploadGroup,
    InputIconGroup,
    DateIconGroup,
    SelectIconGroup
  },
  data () {
    return { 
      generos: [
        {
          id:0,
          value: 'Informe seu Gênero'
        },
        {
          id: 1,
          value: 'Masculino'
        },
        {
          id:2,
          value: 'Feminino'
        },
        { id: 3,
          value: 'Outros'
        },    
      ],
      tipos_processo: [
         {
          id:0,
          value: 'Escolha o tipo de processo'
        },
        {
          id: '999',
          value: 'Paciente'
        },
      ]       
    }
  },

  mounted () {

    AlunosController.getTipoCategorias(function (data) {
          data.dados.map(function (value) {
            self.optionsInputType.push({ id: value.id_tipo_categoria_cnh, value: value.tipo_categoria_cnh })
          })
        })

    if (this.$route.params.idAluno) {
      this.method = 'patch'
      AlunosController.carregaFormularioDeEdicao(this.$route.params.idAluno)
    }    
  },

  created: function () {

    const url = `${urlApi}/alunos/buscar/tipos-de-processos`
    this.$http.get(url).then((res) => {
      const dadosAlunos = res.data.dados.codigos
      dadosAlunos.forEach((codigo) => {
        this.codigosProcesso.push({ 'value': codigo.codigo, 'text': codigo.codigo })
      })
    })
  },

  methods: {

    salvaInformacoes () {
     
       if (this.$route.params.idAluno) {
        AlunosController.updatePaciente(this.$route.params.idAluno)
      }else{
      AlunosController.storePaciente()
      }
    },
    // loadData () {
    //   this.table.load = true
    //   this.$http.get(this.urlCep + this.search + '/json/').then(this.callbackDataPaginate)
    // },
    searchCep (e) {
      AlunosController.searchCep(e)
    },  
   }
 }
</script>

<style scoped>
  input[type="file"] {
    display: none;
  }
</style>
